'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'ui/toast'
import { useState } from 'react'
import { LanguageProvider } from 'i11n/client'
import { ChakraProvider } from '@chakra-ui/react'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import { DashboardLanguage } from 'lib/dashboard-language'

export const Providers = ({
  children,
  lang,
}: {
  children: React.ReactNode
  lang: DashboardLanguage
}) => {
  const [queryClient] = useState(new QueryClient())

  return (
    <NuqsAdapter>
      <LanguageProvider lang={lang}>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          {children}
        </QueryClientProvider>
      </LanguageProvider>
    </NuqsAdapter>
  )
}
